import './project-recent.scss';

export default () => {

};
